// transport
export type * from "./transport/alchemy.js";
export { alchemyTransport, isAlchemyTransport } from "./transport/alchemy.js";

// http -- Revisit exporting this once it has a use case.
// export type * from "./rest/restClient.js";
// export type * from "./rest/types.js";
// export { AlchemyRestClient } from "./rest/restClient.js";

// chain registry utilities
export {
  getAlchemyRpcUrl,
  isChainSupported,
  getSupportedChainIds,
} from "./transport/chainRegistry.js";

// utils
export type * from "./utils/types.js";
export { assertNever } from "./utils/assertNever.js";
export { raise } from "./utils/raise.js";
export { bigIntMultiply, bigIntMax } from "./utils/bigint.js";
export { lowerAddress } from "./utils/lowerAddress.js";

// config
export type { AlchemyConnectionConfig } from "./transport/connectionSchema.js";
export {
  AlchemyConnectionConfigSchema,
  validateAlchemyConnectionConfig,
  isAlchemyConnectionConfig,
} from "./transport/connectionSchema.js";

// errors
export { BaseError } from "./errors/BaseError.js";
export { ChainNotFoundError } from "./errors/ChainNotFoundError.js";
export { AccountNotFoundError } from "./errors/AccountNotFoundError.js";
export { ConnectionConfigError } from "./errors/ConnectionConfigError.js";
export { FetchError } from "./errors/FetchError.js";
export { ServerError } from "./errors/ServerError.js";
export { InvalidRequestError } from "./errors/InvalidRequestError.js";
export { MethodUnsupportedError } from "./errors/MethodUnsupportedError.js";
